/**
 * Constants and utility functions for the Results page.
 */

export const OPTION_COLORS = ['#3b82f6', '#22c55e', '#f59e0b', '#ef4444', '#8b5cf6', '#ec4899', '#14b8a6', '#f97316', '#06b6d4', '#84cc16'];

export const AGE_SEGMENTS_ORDER = [
  "Menors de 20 anys",
  "de 20 a 29 anys",
  "de 30 a 39 anys",
  "de 40 a 49 anys",
  "de 50 a 59 anys",
  "de 60 a 69 anys",
  "de 70 a 79 anys",
  "Majors de 79 anys"
];

export const AGE_SEGMENT_SHORT = {
  "Menors de 20 anys": "<20",
  "de 20 a 29 anys": "20-29",
  "de 30 a 39 anys": "30-39",
  "de 40 a 49 anys": "40-49",
  "de 50 a 59 anys": "50-59",
  "de 60 a 69 anys": "60-69",
  "de 70 a 79 anys": "70-79",
  "Majors de 79 anys": ">79"
};

export function getShortLabel(label) {
  return AGE_SEGMENT_SHORT[label] || label;
}
